import React from "react";
import styles from "./streamCard.module.scss";
import { Media } from "../../../../types/media";
import cx from "classnames";
import Thumbnail from "../../../../components/thumbnail";
import dateFormat from "dateformat";
import { Banner } from "src/types/common";
import { useNavigate } from "react-router-dom";
import Tooltip from "src/components/tooltip";
import { NavigateEntity } from "src/components/NavigateEntity";
import Text from "src/components/text";

interface StreamIconProps {
  id: string;
  icon?: Media;
  name?: string;
  cardStyle: string;
  modifiedDate?: string;
  banner?: Banner;
}

interface PlaceholderStreamCardProps {
  cardStyle: string;
}

const getCardClass = (cardStyle: string) =>
  cardStyle === "LARGE" ? styles.streamIcon : styles.smallStreamIcon;

// Main StreamCard component
export function StreamCard({
  id,
  icon,
  name,
  cardStyle,
  modifiedDate,
  banner
}: StreamIconProps) {
  const cardClass = getCardClass(cardStyle);
  const navigate = useNavigate();

  return (
    <NavigateEntity 
      path={`/streams/${id}`}
      className={styles.cursorPointer} 
      onClick={() => {
        navigate(`/streams/${id}`);
      }}
    >
      <div className={cx(cardClass)}>
        <Thumbnail
          media={icon as Media}
          crop={banner?.crop}
          className={styles.thumbnail}
          position={banner?.position}
          alt="stream thumbnail"
          defaultImage="/images/assets/default_asset.jpg"
          width={800}
        />
        <div className={cx(cardStyle === "SMALL" && styles.smallStreamInfo)}>
          <div className={styles.streamName}>
            <Text text={name} className={styles.name} lines={1} />
          </div>
          {cardStyle === "SMALL" && modifiedDate && (
            <p className={styles.modifiedDate}>
              Last updated on {dateFormat(modifiedDate, "dd mmm yyyy")}
            </p>
          )}
        </div>
      </div>
    </NavigateEntity>
  );
}

// Placeholder version of StreamCard
export function PlaceholderStreamCard({
  cardStyle,
}: PlaceholderStreamCardProps) {
  const cardClass = getCardClass(cardStyle);

  return (
    <div className={cx(cardClass, styles.placeholder)}>
      <div className={cx(styles.thumbnail, styles.block)}></div>
      <p className={cx(styles.streamName, styles.block)}></p>
    </div>
  );
}
